import { createStyles, Grid, makeStyles, Theme } from "@material-ui/core";
import useText from "constants/text";
import { ITourTemplateAxe, NewRequestQuoteContext } from "contexts/RequestQuoteContext";
import { TemplateStop } from "generated/graphql";
import React, { useState } from "react";
import Navigation from "./Navigation";
import { TourAxes } from "./TourAxes";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: "30px",
      display: "block",
      margin: "auto",
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        marginTop: "30px",
        display: "contents",
      },
    },
    switchContainer: {
      marginBottom: "20px",
      textAlign: "center",
      display: "block",
      margin: "auto",
    },
    productContainer: {
      borderRadius: "10px",
      width: "95%",
      display: "block",
      margin: "auto",
      minheight: "150px",
      border: "solid 1px #ccc",
      marginTop: "20px",
    },
    divContainer: {
      height: "63vh",
      overflowY: "scroll",
      overflowX: "hidden",
      [theme.breakpoints.down("xs")]: {
        overflowY: "auto",
        height: "57vh",
      },
    },
  })
);

interface TourShipmentProps {
  onNext: () => void;
  onBack?: () => void;
}

const Stops = ({ onNext, onBack }: TourShipmentProps) => {
  const { text } = useText();
  const classes = useStyles();
  const { requestQuoteTour, requestQuoteDetails } = React.useContext(NewRequestQuoteContext);
  const [isEdited, setIsEdited] = useState(false);
  const goToNext = () => {
    onNext();
    setIsEdited(true);
  };
  const isValidStop = (stop: TemplateStop) => stop.address;
  const isValidAxe: any = (templateAxe: ITourTemplateAxe) =>
    templateAxe?.name && templateAxe?.templateStops?.every(isValidStop) && templateAxe?.vehicles?.length;

  const nextDisabled = React.useMemo(() => {
    return !requestQuoteTour?.templateAxes?.every(isValidAxe);
  }, [requestQuoteTour, requestQuoteDetails]);
  return (
    <>
      <div className={classes.divContainer}>
        <Grid xs={6} container direction="column" spacing={5} className={classes.root}>
          <TourAxes isEdited={isEdited} />
        </Grid>
      </div>
      <Navigation nextTitle={text.all.next} onNext={goToNext} disableNext={nextDisabled} />
    </>
  );
};

export default Stops;
